import { AppDispatch } from '../../redux/store';
import CardWrapper from '../../components/wrapper/card';
import { fetchAllDealsThunk } from '../../redux/thunks/deal';
import RoloDexComponent from '../../components/rolodex';
import { useDispatch } from 'react-redux';
import { Box, Typography } from '@mui/material';
import React, { useEffect } from 'react';

const RoloDexPage = () => {
    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        const fetchRolodexDeals = async () => {
            try {
                await dispatch(fetchAllDealsThunk()).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchRolodexDeals();
    }, []);

    return (
        <Box p={3} minHeight="80vh" overflow="auto" pb="100px">
            <CardWrapper>
                <Typography variant="h4" color="textSecondary" gutterBottom>
                    Rolodex
                </Typography>
                <Typography variant="subtitle1" color="textSecondary" gutterBottom>
                    Access and manage all your contacts effortlessly with the Rolodex, keeping key information easily available.
                </Typography>
                <RoloDexComponent />
            </CardWrapper>
        </Box>
    );
};

export default RoloDexPage;
